import { VpIcon, VpIconSize } from '@vtmn-play/react'
import { getScoreIconColor } from '@/src/utils/scoreUtils'
import { HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

type ScoreIndicatorProps = {
  size: 'small' | 'medium' | 'large'
  score: number
  direction?: 'horizontal' | 'vertical'
} & HTMLAttributes<HTMLDivElement>

const scoreIndicatorSizeConfig: Record<
  ScoreIndicatorProps['size'],
  { iconSize: VpIconSize; textSize: string; gapSize: string }
> = {
  small: { iconSize: 24, textSize: 'text-xl', gapSize: 'gap-1' },
  medium: { iconSize: 48, textSize: 'text-[26px]', gapSize: 'gap-2' },
  large: { iconSize: 48, textSize: 'text-4xl', gapSize: 'gap-3' },
}

const ScoreIndicator = ({
  score,
  size,
  direction = 'horizontal',
  className,
  ...htmlProps
}: ScoreIndicatorProps) => {
  // large icon is 64px (32 with scale-200)
  const { iconSize, textSize, gapSize } = scoreIndicatorSizeConfig[size]
  const flexDirectionClass = direction === 'horizontal' ? 'flex-row' : 'flex-col'
  return (
    <div
      className={twMerge(
        `flex text-2 flex-col justify-center items-center text-white ${gapSize}`,
        flexDirectionClass,
        className
      )}
      {...htmlProps}
    >
      <VpIcon
        data-testid="shield-check-icon"
        className={`${size === 'large' ? 'scale-200' : ''} ${getScoreIconColor(score)}`}
        name="shield-check"
        size={iconSize}
      />
      <div data-testid="score-value" className={`${textSize} font-semibold`}>
        {score}%
      </div>
    </div>
  )
}

export default ScoreIndicator
